<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
      </b-button>

      <b-container style="max-width: 90%; margin: auto;">
        <b-row>
          <b-col md="12" class="mt-4 mb-4">
            
              <div class="divisor">
                {{ $t('crear_nuevo_usuario') }}
              </div>
            
          </b-col>

         
        </b-row>
        
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="4">
              <b-form-group label-for="nombreContacto">
                <template v-slot:label>
                  {{ $t('nombre') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="nombreContacto" v-model="form.nombreContacto" required
                  :placeholder="$t('nombre')" ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="apellidoContacto">
                <template v-slot:label>
                   {{ $t('apellido') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="apellidoContacto" v-model="form.apellidoContacto" required
                  :placeholder="$t('apellido')" ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="idRol">
                <template v-slot:label>
                  {{ $t('rol') }} <span class="text-danger">*</span>
                </template>
                <b-form-select id="idRol" v-model="form.idRol" required>
                  <option :value="null" disabled>{{ $t('seleccione_rol') }}</option>
                  <option v-for="option in opcionesRoles" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="telefono">
                <template v-slot:label>
                   {{ $t('telefono') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="telefono" v-model="form.telefono" required :placeholder="$t('telefono')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="correo">
                <template v-slot:label>
                   {{ $t('correo') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="correo" v-model="form.correo" required :placeholder="$t('correo')"
                  autocomplete="off"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="idPais">
                <template v-slot:label>
                   {{ $t('locacion') }}  <span class="text-danger">*</span>
                </template>
                <b-form-select id="idPais" v-model="form.idPais" required>
                  <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                  <option v-for="option in opcionesPaises" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="password">
                <template v-slot:label>
                  {{ $t('contrasena') }} <span class="text-danger">*</span>
                </template>
                <div class="input-group">
                  <b-form-input @blur="validatePassword" @change="validatePassword" class="border rounded-left rounded-right-none" required
                    :placeholder="$t('contrasena')" :type="showPassword ? 'text' : 'password'" v-model="form.password"
                    autocomplete="new-password"></b-form-input>
                  <div class="input-group-append rounded-left-none">
                    <button class="btn btn-outline-secondary border rounded-right rounded-left-none" type="button"
                      @click="togglePassword">
                      <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </button>
                  </div>
                </div>
                <span v-if="passwordError" style="color: red; font-size: 12px;">{{$t('contrasena_caracteres')}}</span>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="confirmPassword">
                <template v-slot:label>
                  {{ $t('confirmar_contrasena') }} <span class="text-danger">*</span>
                </template>
                <div class="input-group">
                  <b-form-input @blur="validatePassword" @change="validatePassword" class="border rounded-left" required
                    :placeholder="$t('confirmar_contrasena')" :type="showPassword ? 'text' : 'password'" v-model="password"
                    autocomplete="new-password"></b-form-input>
                </div>
                <span v-if="passwordError2" style="color: red; font-size: 12px;">{{$t('contrasena_caracteres')}}</span>
                <span v-else-if="!passwordIgual" style="color: red; font-size: 12px;">{{$t('contrasena_iguales')}}</span>
              </b-form-group>
            </b-col>
            <b-col md="4">
              
            </b-col>
            <b-col v-if="form.idRol == 3" md="4">
              <b-form-group label-for="idZona">
                <template v-slot:label>
                   {{ $t('zona') }} <span class="text-danger">*</span>
                </template>
                <b-form-select id="idZona" v-model="form.idZona" required>
                  <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                  <option v-for="option in opcionesZonas" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>


          <b-button type="submit" variant="primary">
             {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import usuarioService from '@/api/userService';
import zonaService from '@/api/zonaService';
import paisService from '@/api/paisService';
import { Select, Option } from 'element-ui'

export default {
  name: 'UsuarioCrear',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      form: {
        nombreEmpresa: '',
        rutEmpresa: '',
        direccion: '',
        industria: '',
        web: '',
        telefono: '',
        password: '',
        nombreContacto: '',
        apellidoContacto: '',
        correo: '',
        idRol: null,
        idZona: null,
        idEmpresa: 0,
        idPais: null,
        // Idioma del correo de bienvenida. Lo elige el administrador en el diálogo
        // de confirmación, porque el usuario nuevo puede no hablar el idioma en que
        // está trabajando quien lo da de alta.
        lang: 'es',
      },
      password: '',
      showPassword: false,
      passwordError: false,
      passwordError2: false,
      passwordIgual: true,
      opcionesZonas: [],
      opcionesRoles: [],
      opcionesPaises: [],
    };
  },
  async beforeMount() {
    const rolesPromise = usuarioService.getRolesOptions();
    const zonasPromise = zonaService.getZonasOptions();
    this.opcionesRoles = await rolesPromise;
    this.opcionesZonas = await zonasPromise;
    const paises = await paisService.getAll();
    this.opcionesPaises = paises
      .map(p => ({ value: p.idPais, text: p.nombre }))
      .sort((a, b) => String(a.text || '').localeCompare(String(b.text || ''), 'es', { sensitivity: 'base' }));
  },
  methods: {
    validatePassword() {
      if (this.form.password.length > 0) this.passwordError = this.form.password.length < 5;
      if (this.password.length > 0) this.passwordError2 = this.password.length < 5;
      this.passwordIgual = this.form.password === this.password;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async submitForm() {
  if (this.passwordError || !this.passwordIgual) {
    this.$toast.error(this.$t('contrasena_no_valida'), {
      position: 'top-center',
      timeout: 2000,
      closeOnClick: true,
      pauseOnHover: true
    });
    return;
  }

  Swal.fire({
    title: this.$t('esta_seguro'),
    // La pregunta va en el html y no en inputLabel: esa opción existe desde
    // SweetAlert2 v10 y el proyecto usa la v9, donde se ignora sin avisar.
    html: `${this.$t('verificar_datos_pregunta')}`
      + `<p style="margin:16px 0 0;font-weight:600;color:#545454;">${this.$t('idioma_correo_bienvenida')}</p>`,
    icon: 'warning',
    input: 'radio',
    inputOptions: { es: 'Español', en: 'English' },
    // Preseleccionado el idioma en que trabaja el administrador, que es lo más
    // probable, pero queda a la vista para poder cambiarlo.
    inputValue: this.$getLanguage() === 'en' ? 'en' : 'es',
    inputValidator: (value) => (value ? undefined : this.$t('seleccione_idioma_correo')),
    showCancelButton: true,
    confirmButtonText: this.$t('crear'),
    cancelButtonText: this.$t('cancelar')
  }).then(async (result) => {
    if (!result.isConfirmed) {
      Swal.close();
      return;
    }

    // El idioma elegido viaja con el alta: el backend arma el correo con él.
    this.form.lang = result.value === 'en' ? 'en' : 'es';

    try {
      Swal.fire({
        html: '<div style="display:flex;align-items:center;justify-content:center;">' +
              '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
              `<div><h3 style="color:#006393;">${this.$t('creando')}</h3></div>` +
              '</div>',
        showConfirmButton: false,
        allowOutsideClick: false
      });

      // Enviar el formulario tal como lo tienes
      const response = await usuarioService.create(this.form);

      if (!response || !response.data) {
        Swal.fire({ icon: 'error', title: 'Oops...', text: this.$t('error_desconocido') });
        return;
      }

      Swal.fire({
        title: this.$t('creado_correctamente'),
        text: this.$t('usuario_correo_bienvenida_enviado'),
        icon: 'success',
        showConfirmButton: false,
        timer: 3000
      });

      // Ajusta si tu backend devuelve el id en otro campo
      var newId = (response.data && (response.data.id || response.data.ID || response.data.userId)) ? 
                  (response.data.id || response.data.ID || response.data.userId) : null;

      if (newId) {
        this.$router.push('/usuarios/detalle/' + newId);
      } else {
        this.$router.go(-1);
      }
    } catch (error) {
  // Log útil en consola para depurar el payload real
  var raw = (error && error.response) ? error.response.data : error;
  try { console.error('Create user error payload:', raw); } catch (e) {}

  // Código de estado
  var status = 0;
  if (error && error.response && typeof error.response.status !== 'undefined') {
    status = error.response.status;
  }

  // Normaliza mensaje -> string
  var msg = 'Error';
  if (typeof raw === 'string') {
    msg = raw;
  } else if (raw && (raw.message || raw.Message || raw.error || raw.title || raw.detail)) {
    msg = String(raw.message || raw.Message || raw.error || raw.title || raw.detail);
  } else if (error && error.message) {
    msg = error.message;
  } else {
    try { msg = JSON.stringify(raw, null, 2); } catch (e) { msg = 'Error'; }
  }

  // Si quedó objeto por algún motivo, fuerzo stringify
  if (typeof msg !== 'string') {
    try { msg = JSON.stringify(msg, null, 2); } catch (e) { msg = 'Error'; }
  }

  // Usa html+<pre> para que nunca salga [object Object] y se lea mejor
  var title = (status === 409) ? this.$t('correo_ya_registrado') :
              (status === 400) ? this.$t('datos_invalidos') : 'Oops...';
  var icon  = (status === 409 || status === 400) ? 'warning' : 'error';

  Swal.fire({
    icon: icon,
    title: title,
    html: '<pre style="font-family: inherit;text-align:center;white-space:pre-wrap;margin:0">'+this.$t('correo_ya_registrado_texto')+'</pre>'
  });
}
  });
}
  }
};
</script>
